import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import AnimationWrapper from 'components/AnimationWrapper';
import PropTypes from 'prop-types';

const Container = styled.section`
  width: 100%;
  margin: 0 auto;
  padding: 4rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  ${({ theme }) => theme.mediaQueries.sm} {
    padding: 8rem 3rem;
    gap: 4rem;
  }

  section {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0rem 1rem;

    ${({ theme }) => theme.mediaQueries.lg} {
      grid-template-columns: repeat(4, 1fr);
      gap: 0;
    }
  }
`;
const Title = styled.h2`
  ${({ theme }) => theme.mixins.Mono};
  color: ${({ theme }) => theme.colors.gray};
  text-align: center;
  display: block;

  ${({ theme }) => theme.mediaQueries.lg} {
    display: none;
  }
`;
const GalleryItem = styled(Link)`
  width: 100%;
  height: 100%;
  min-height: 13rem;
  border-top: 1px solid ${({ theme }) => theme.colors.gray};
  position: relative;
  ${({ theme }) => theme.mixins.flexRowCenter};
  padding: 20% 36%;

  img {
    transition: opacity 0.3s ease;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    &:hover {
      img {
        opacity: 0.25;
      }
    }
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    border-top: none;
    border-left: 1px solid ${({ theme }) => theme.colors.gray};
    &:first-of-type {
      border-left: none;
    }
  }
`;

const ItemImage = styled.img`
  height: 100%;
  width: 12rem;
  object-fit: contain;
  pointer-events: none;
  user-select: none;
`;
const CallToAction = styled.div`
  cursor: pointer;
  width: 100%;
  height: 100%;
  padding: 4rem;
  border-top: 1px solid ${({ theme }) => theme.colors.gray};
  position: relative;
  ${({ theme }) => theme.mixins.flexRowCenter};

  p {
    ${({ theme }) => theme.mixins.Mono};
    color: ${({ theme }) => theme.colors.white};
    text-align: center;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    p {
      ${({ theme }) => theme.mixins.MonoM};
      text-align: center;
      transition: color 0.3s ease;
    }

    &:hover {
      p {
        color: ${({ theme }) => theme.colors.accent};
      }
    }
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    border-top: none;
    border-left: 1px solid ${({ theme }) => theme.colors.gray};
  }
`;

const HomeClients = ({ content, id = '' }) => {
  const { title, galleryItems, cta } = content;

  const handleScroll = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <Container id={id}>
      <Title>{title}</Title>
      <AnimationWrapper threshold={0.2} as="section">
        {galleryItems.map((galleryItem, index) => (
          <GalleryItem
            key={index}
            to={galleryItem.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <ItemImage
              src={galleryItem.src}
              alt={galleryItem.alt}
              loading="lazy"
              decode="async"
            />
          </GalleryItem>
        ))}
        <CallToAction onClick={() => handleScroll('contact')}>
          <p>{cta}</p>
        </CallToAction>
      </AnimationWrapper>
    </Container>
  );
};
HomeClients.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    galleryItems: PropTypes.array.isRequired,
    cta: PropTypes.string.isRequired,
  }),
  id: PropTypes.string,
};
export default HomeClients;
